<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="order_order_no" [ttModel]="edit.order_order_no" [ttButtons]="orderButtons" ttReadonly></tt-input>
        <tt-input ttLabel="stat_cust_name" [ttModel]="edit.stat_cust_name" [ttButtons]="statCustNameButtons" ttReadonly></tt-input>
        <tt-input-phone ttLabel="cust_telephone" [ttModel]="edit.cust_telephone" ttReadonly></tt-input-phone>
        <tt-date ttLabel="deliverydate" [ttModel]="edit.deliverydate" ttReadonly></tt-date>
        <tt-textarea ttLabel="remarks" [(ttModel)]="edit.remarks"></tt-textarea>
        <tt-checkbox ttLabel="is_communicated" [(ttModel)]="edit.is_communicated"></tt-checkbox>
        <tt-input ttLabel="reg_datetime" [ttModel]="edit.reg_datetime" ttReadonly></tt-input>

        <div *ngIf="edit.mod_by_portal_user_keyno !== '0'">
            <tt-input ttLabel="mod_by_portal_user_name" [ttModel]="edit.mod_by_portal_user_name" ttReadonly></tt-input>
            <tt-input ttLabel="mod_datetime" [ttModel]="edit.mod_datetime" ttReadonly></tt-input>
        </div>

        <tt-button-goto [ttText]="'orderhead_email_send'" [ttGoto]="'emailcreate'" [ttGotoParms]="{ webpage: 'orderhead', argtype: 'order_internal_no', argvalue: edit.order_internal_no }"></tt-button-goto>
        <tt-button-save ttText="save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
